import React from 'react';
import FormControl from 'components/Core/FormControl';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import Button from 'components/Core/Button';
import HyperLink from 'components/Core/HyperLink';
import TextField from 'components/Core/TextField';
import LoginOptions from 'components/Page/Toolbox/LoginOptions';
import SeparatorLineText from 'components/SeparatorLineText';
import { getFormValid } from 'utils/formUtils';
import { LoginContainer, ForgotPasswordLink } from './styles';

const LoginModalContainer = ({
  auth,
  socialAuth,
  openSignupModal,
  forgotPasswordClick,
  authError,
  ...otherProps
}) => {
  const { values, handleChange, handleBlur, handleSubmit, submitCount, touched, errors, isValid } =
    otherProps;

  const formValid = getFormValid({ errors, submitCount });

  return (
    <LoginContainer>
      <h4>Login to the Toolbox</h4>
      <LoginOptions onClick={socialAuth} />
      <SeparatorLineText text="or with email" />
      <div className="login-modal--form-container">
        <div>
          <FormControl fullWidth className="login-modal--form-item">
            <TextField
              id="email"
              type="text"
              values={values}
              formValid={formValid}
              formErrors={errors}
              placeholderText="Email"
              onChange={handleChange}
              onBlur={handleBlur}
              showOnlyFormError
            />
          </FormControl>
          <FormControl fullWidth className="login-modal--form-item">
            <TextField
              id="password"
              type="password"
              values={values}
              formValid={formValid}
              formErrors={errors}
              placeholderText="Password"
              onChange={handleChange}
              onBlur={handleBlur}
              showOnlyFormError
            />
          </FormControl>
          {authError && (
            <FormControl fullWidth className="login-modal--form-item">
              <p className="input-failed-value">{authError}</p>
            </FormControl>
          )}
          <ForgotPasswordLink onClick={forgotPasswordClick}>Forgot Password?</ForgotPasswordLink>
          <FormControl fullWidth className="login-modal--form-item">
            <Button
              type="secondary"
              width="100%"
              shadow={false}
              disabled={!isValid}
              button
              onClick={handleSubmit}
            >
              Log In
            </Button>
          </FormControl>
        </div>
        <h6>
          Not a member? <HyperLink onClick={openSignupModal}>Join Toolbox</HyperLink>
        </h6>
      </div>
    </LoginContainer>
  );
};

const vSchema = Yup.object().shape({
  email: Yup.string().email('Please enter a valid email').required('Email is required'),
  password: Yup.string().required('Password is required'),
});

export default withFormik({
  validationSchema: vSchema,
  handleSubmit: (values, { props, setErrors }) => {
    props.auth(values.email, values.password);
  },
})(LoginModalContainer);
